import { useEffect, useRef, useState } from "react";

const useCountdown = () => {
    const [counting, setCounting] = useState(false);
    const [countdown, setCountdown] = useState(59);

    const timerRef = useRef<NodeJS.Timeout>();
    const countdownRef = useRef<NodeJS.Timeout>();

    const startCountdown = () => {
        setCounting(true);

        countdownRef.current = setInterval(() => {
            setCountdown(state => state - 1);
        }, 1000);

        timerRef.current = setTimeout(() => {
            clearInterval(countdownRef.current), setCounting(false), setCountdown(60);
        }, 60000);
    };

    useEffect(() => {
        return () => {
            countdownRef.current && clearInterval(countdownRef.current);
            timerRef.current && clearTimeout(timerRef.current);
        };
    }, []);

    return {
        startCountdown,
        countdown,
        counting,
    };
};

export default useCountdown;
